<div class="row p-3">
    <div class="col">
      <app-busqueda></app-busqueda>
    </div>
</div>
<hr />

<div class="ro">
    <div class="col">
      <app-resultado></app-resultado>
    </div>
</div>